import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

/**
 * Rotas do módulo de notas.
 *
 * Uma só, e **protegida por sessão**: a nota mora em `user_notes` com
 * `profile_id` como chave, e a RLS só devolve linha para o dono. Convidado não
 * tem o que ver aqui — a `RequireSession` o manda ao login com `?next=/notes` e
 * ele volta direto para o campo.
 *
 * Entra sob o `AppLayout`, e não no ramo de fluxos de tarefa: é uma tela-destino
 * do menu, como Chamados e Doações, e quem termina de anotar espera a barra
 * inferior ali para seguir para outro lugar. Não há formulário em etapas cujo
 * trabalho um toque acidental pudesse descartar — o campo salva sozinho.
 */
const NotesPage = lazy(() => import('./routes/Notes.page'));

export const notesRoutes: RouteObject[] = [{ path: 'notes', element: <NotesPage /> }];
